import React, { useMemo } from 'react'
import { Column } from 'react-table'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import { Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material'

import { insertIf } from '../../../../../../utils-next/arrays'
import { history } from '../../../../../../duck/store'
import { getScoutingCampaignDetailsPath } from '../../../ScoutingCampaignManager'
import { getUserDetailsPath } from '../../../UsersManager'
import { Subspace } from '../../../../../../entities-next/subspace'

export function useSubspaceDataRows(extraRows: Column<Subspace>[]): Column<Subspace>[] {
  const theme = useTheme()
  const mediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'))
  const largeScreenSize = useMediaQuery(theme.breakpoints.up('lg'))

  return useMemo(() => [...baseUserRowData(), ...insertIf(largeScreenSize, extraRowData()), ...extraRows], [
    theme,
    extraRows,
    largeScreenSize,
    mediumScreenSize,
  ]) as any
}

const baseUserRowData = () => [
  {
    Header: 'Id',
    accessor: getSubspaceId,
    maxWidth: 32,
  },
  {
    Header: 'Name',
    accessor: getSubspaceName,
  },
  {
    Header: 'Description',
    accessor: getSubspaceDescription,
  },
  {
    Header: 'User Id',
    accessor: getUserId,
    maxWidth: 32,
  },
  {
    Header: 'Space Id',
    accessor: getSpaceId,
    maxWidth: 32,
  },
]

const extraRowData = () => []

function getSubspaceId({ id }: Subspace) {
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(id.toString())
    e.stopPropagation()
  }
  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info">
        {id}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}

function getSubspaceName({ name }: Subspace) {
  return <span style={{ whiteSpace: 'normal' }}>{name}</span>
}

function getSubspaceDescription({ description }: Subspace) {
  return <span style={{ whiteSpace: 'normal' }}>{description}</span>
}

function getUserId({ userId }: Subspace) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    history.push(getUserDetailsPath(userId))
    e.stopPropagation()
  }
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(userId.toString())
    e.stopPropagation()
  }

  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info" onClick={handleClick} title="Go to user details">
        {userId}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy user id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}

function getSpaceId({ spaceId }: Subspace) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    history.push(getScoutingCampaignDetailsPath(spaceId))
    e.stopPropagation()
  }
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(spaceId.toString())
    e.stopPropagation()
  }

  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info" onClick={handleClick} title="Go to space details">
        {spaceId}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy space id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}
